import React, { useReducer, useContext, useMemo } from 'react';
import deepClone from 'lodash.clonedeep';
// import RFQ from '../../Components/RFQ';

export const AppContext = React.createContext();

const initialState = {
  isEditable: false,
  transporterInfo: {},
  companies: [],
  clientIp: "",
  showLoader: false,
  validate: {},
  navigatigAway: false,
  RFQ: false,
  IsRFQ: true,
  loggedInPhone: ""
};

export const AppContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const userName = useMemo(() => {
    const phone = state.loggedInPhone?.replace(/\s/g, "") || "";
    const contacts = state.transporterInfo?.contact_information || [];

    const match = contacts.find((contact) => {
      const contactPhone = (contact.contact_number || "").replace(/\s/g, "");
      return (
        contactPhone === phone ||
        contactPhone.endsWith(phone) ||
        phone.endsWith(contactPhone)
      );
    });

    return match?.name || "";
  }, [state.transporterInfo, state.loggedInPhone]);
  const value = { ...state, dispatch, userName };

  localStorage.setItem("userName", userName);

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useAppContext = () => useContext(AppContext);

// Reducers
const reducer = (state, action) => {
  let new_state = null;

  switch (action.type) {
    case ContextConstants.SetData: {
      return { ...state, transporterInfo: action.payload, RFQ: false };
    }
    case ContextConstants.SetLoggedInPhone: {
      return { ...state, loggedInPhone: action.payload };
    }
    case ContextConstants.SetCompanies: {
      return { ...state, companies: action.payload, RFQ: false };
    }

    case ContextConstants.ToggleEdit: {
      return { ...state, isEditable: !state.isEditable, RFQ: false };
    }
    case ContextConstants.ToggleLoaderState: {
      return { ...state, showLoader: !state.showLoader, RFQ: false };
    }
    case ContextConstants.AddGeneralInfoPageValidation: {
      const val = deepClone(state.validate);
      val.GeneralInfo = action.payload;
      return { ...state, validate: val, RFQ: false };
    }
    case ContextConstants.AddBusinessProfilePageValidation: {
      const val = deepClone(state.validate);
      val.BusinessProfile = action.payload;
      return { ...state, validate: val, RFQ: false };
    }
    case ContextConstants.AddOperationsOverviewPageValidation: {
      const val = deepClone(state.validate);
      val.OperationsOverview = action.payload;
      return { ...state, validate: val, RFQ: false };
    }
    case ContextConstants.AddCustomerDetailsValidation: {
      const val = deepClone(state.validate);
      val.CustomerDetails = action.payload;
      return { ...state, validate: val, RFQ: false };
    }
    case ContextConstants.NavigatingAway: {
      return { ...state, navigatigAway: action.payload, RFQ: false };
    }
    case ContextConstants.UpdateContacts: {
      new_state = { ...state };
      new_state.transporterInfo.contact_information = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.UpdateCustomers: {
      new_state = { ...state };
      new_state.transporterInfo.company_details = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.UpdateReferences: {
      new_state = { ...state };
      new_state.transporterInfo.customer_reference = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.FirstUpdateReferences: {
      new_state = { ...state };
      new_state.transporterInfo.customer_reference = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.UpdateShipmentMethods: {
      new_state = { ...state };
      new_state.transporterInfo.shipment_tracking_method = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.UpdateTMS: {
      new_state = { ...state };
      new_state.transporterInfo.tms_experience = action.payload;
      new_state.RFQ = false
      return new_state;
    }

    case ContextConstants.UpdateTruckAssetDetails: {
      new_state = { ...state };
      new_state.transporterInfo.truck_asset_details = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.AddAttachments: {
      new_state = { ...state };
      new_state.transporterInfo.attachments = action.payload;
      new_state.RFQ = false
      return new_state;
    }
    case ContextConstants.getAuthEmailValid: {
      const val = deepClone(state.validate);
      val.Contract = action.payload;
      return { ...state, validate: val, RFQ: false };
    }
    //UpdateTruckAssetDetails
    //return { ...state, accessToken: action.payload };
    case ContextConstants.ToggleRFQ: {
      return { ...state, RFQ: true };
    }
    case ContextConstants.IsRFQ: {
      return { ...state, RFQ: true };
    }
    case ContextConstants.updatePercentage: {
      new_state = { ...state }
      new_state.transporterInfo.percentage_completion = action.payload
      // console.log(new_state)
      return new_state
    }
    case ContextConstants.updateTenderList: {
      new_state = { ...state }
      new_state.transporterInfo.user_procurement_data = action.payload
      return new_state
    }
    case ContextConstants.updateRequestRatingsTimestamp: {
      new_state = { ...state }
      new_state.transporterInfo.requestRatings_timestamp = action.payload
      return new_state
    }
    case ContextConstants.updateOperationPercentage: {
      new_state = { ...state }
      new_state.transporterInfo.modes_of_operation = action.payload
      return new_state
    }
    case ContextConstants.clientIp: {
      return { ...state, clientIp: action.payload };
    }
    default:
      return state;
  }
};

export const ContextConstants = {
  SetData: 'Set_Data',
  SetCompanies: 'Set_Companies',
  ToggleEdit: 'Toggle_Edit',
  ToggleLoaderState: 'Toggle_Loader_State',
  AddGeneralInfoPageValidation: 'Add_GeneralInfo_Validation',
  AddBusinessProfilePageValidation: 'Add_BusinessProfile_Validation',
  AddOperationsOverviewPageValidation: 'Add_OperationsOverview_Validation',
  AddCustomerDetailsValidation: 'Add_CustomerDetails_Validation',
  NavigatingAway: 'Navigating_Away',
  UpdateContacts: 'Update_Contacts',
  UpdateCustomers: 'Update_Customers',
  UpdateReferences: 'Update_References',
  UpdateShipmentMethods: 'Update_Shipment_Methods',
  UpdateTMS: 'Update_tms',
  UpdateTruckAssetDetails: 'Update_Truck_Asset_Details',
  AddAttachments: 'Add_Attachments',
  ToggleRFQ: 'RFQ',
  IsRFQ: 'Disable Edit',
  getAuthEmailValid: 'Auth_Sig_email',
  updatePercentage: 'Update Percentage',
  updateTenderList: 'Update User Tender List',
  updateRequestRatingsTimestamp: 'Update Request Ratings TimeStamp',
  updateOperationPercentage: 'Update Operation Percentage',
  clientIp: "Client IP",
  SetLoggedInPhone: 'Set_Logged_In_Phone',
};
